import { render, staticRenderFns } from "./ScrapbookCard.vue?vue&type=template&id=abc28fc0&"
import script from "./ScrapbookCard.vue?vue&type=script&lang=js&"
export * from "./ScrapbookCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports